<template>
  <div
    class="bg-black-transparent absolute w-full h-full backdrop-filter backdrop-blur-sm top-0 left-0 flex items-center justify-center">
    <div class="bg-white classen__rounded w-9/10 h-6/10 1.5xl:w-5/10 max-h-full header p-5 ">

      <div class="grid grid-cols-3">
        <p class="text-2xl col-start-2 justify-self-center">{{
            getTranslation('imageSelection')
          }}</p>
        <p @click="$emit('close')" class="text-2xl col-start-3 justify-self-end"><i
          class="fas fa-times"></i>
        </p>
      </div>

      <div v-if="presets.length > 0" class="grid grid-cols-3 gap-6 mt-4 overflow-y-auto h-9/10">
        <template v-for="preset in presets">
          <img :src="preset.src" :alt="preset.room" class="option classen__rounded"
               @click="selectPreset(preset)"/>
        </template>
      </div>

      <div v-else class="grid grid-cols-3">
        <p class="col-start-2 justify-self-center mt-56">{{
            getTranslation('noRoomscenesAvailable')
          }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import getTranslation from "../../../../../mixins/getTranslation";

export default {
  name: "TemplatePicker",

  mixins: [getTranslation],

  props: {
    presets: {required: true},
  },

  methods: {
    selectPreset(value) {
      this.$emit('presetSelected', value);
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.option {
  height: 150px;
  width: 230px
}
</style>
